import CodeSwitcher from '@/docs-partials/resources/code-examples.mdx';
import * as React from 'react';
export default {
  CodeSwitcher,
  React
};